import { render, staticRenderFns } from "./ListadoDeportistas.vue?vue&type=template&id=00fc1732&scoped=true"
import script from "./ListadoDeportistas.vue?vue&type=script&lang=js"
export * from "./ListadoDeportistas.vue?vue&type=script&lang=js"
import style0 from "./ListadoDeportistas.vue?vue&type=style&index=0&id=00fc1732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc1732",
  null
  
)

export default component.exports